export default "__VITE_ASSET__BtIjb_oG__"